import api from './api';

export const getAllCorporateDeposits = () => api.get('/corporate-deposits');
export const getCorporateDepositById = (id) => api.get(`/corporate-deposits/${id}`);
export const createCorporateDeposit = (data) => api.post('/corporate-deposits', data);
export const updateCorporateDeposit = (id, data) => api.put(`/corporate-deposits/${id}`, data);
export const deleteCorporateDeposit = (id) => api.delete(`/corporate-deposits/${id}`);
export const uploadCorporateDepositMedia = (formData) => api.post('/corporate-deposits/upload-media', formData);
